import {FeatureObject} from '../../types/FeatureObject';
import {FeatureStatus} from '../../types/FeatureStatus';

/**
 * Filter features by included statuses
 * @param includeStatus
 * @returns
 */
export function filterByIncludeStatus(includeStatus?: FeatureStatus[]): (f: FeatureObject) => boolean {
  return (f) => !includeStatus || includeStatus.includes(f.status);
}
